import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { State } from '../../../../core/store';
import { Store } from '@ngrx/store';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { loadEmployeeUsers, loadViewableCampuses } from '../../../../core/store/employee/employee.action';
import { SelfCareCompletionReportModel } from '../../../../models/selfcareModels';
import { SelectItem } from 'primeng/api';
import { deepClone, downloadFile } from '../../../../helpers/utils';
import { exportSelfCareCompletionListToExcel, exportSelfCareCompletionListToExcelSuccess, getSelfCareCompletionList } from '../../../../core/store/selfcare/selfcare.actions';
import { tap } from 'rxjs';
import { UserAutoCompleteItem } from '../../../../models/utilModels';

@Component({
    selector: 'app-list-selfcare-complete',
    templateUrl: './list-selfcare-complete.component.html',
    styleUrls: ['./list-selfcare-complete.component.scss'],
    standalone: false
})
export class ListSelfcareCompleteComponent extends BaseComponent implements OnInit {
  list: PagingResultsModel<SelfCareCompletionReportModel>;
  filter: any;

  loadingList: boolean = true;
  loadingExcel: boolean = false;

  campusList: SelectItem[];
  campusId: number = 0;

  selectedUserEmployee: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];
  userId: number = 0;

  statusOptions: SelectItem[];
  status: string = null;

  showOnlyActive: boolean = true;
  canSeeSelfcare;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private store: Store<State>
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.selfcareState.loadingCompletionList).subscribe(loading => {
        this.loadingList = loading;
      }),
      this.store.select(s => s.selfcareState.loadingCompletionExcel).subscribe(loading => {
        this.loadingExcel = loading;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canSeeSelfcare = permissionIDs && !!permissionIDs.find(p => p === 3083); //View Self Care Oversight
      }),
      this.store.select(s => s.employeeState.campuses).subscribe(campuses => {
        this.campusList = campuses && campuses.length > 0 ? campuses
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
      this.store.select(s => s.selfcareState.completionList).subscribe(report => {
        this.list = report;
        if(report != null)
     	  	  	  this.totalRecords.set(report.totalRecords);

      }),
      this.actions$.pipe(
        ofType(exportSelfCareCompletionListToExcelSuccess),
        tap(action => {
          downloadFile(action.doc, 'SelfCareCompletionReport.xlsx');
        })
      ).subscribe()
    );

    this.statusOptions = [
      { label: 'All', value: null },
      { label: 'Complete', value: 'COMPLETE' },
      { label: 'Incomplete', value: 'INCOMPLETE' }
    ];
    this.store.dispatch(loadViewableCampuses());
  }


  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }

  reloadList() {
    this.setFilter();

    this.store.dispatch(getSelfCareCompletionList({
      filter: this.filter
    }));
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      campusId: this.campusId,
      payrollClassificationId: null,
      showTerminated: !this.showOnlyActive,
      showInactive: !this.showOnlyActive
    }));
  }

  reloadListAfterStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterClear(event) {
    
    this.userId = 0;
    this.reloadList();
  }

  setFilter() {
    this.filter = deepClone(this.filter);
    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.campusId = { Name: 'campusId', Value: { value: this.campusId.toString() } };
    this.filter.filters.status = { Name: 'status', Value: { value: this.status } };
    this.filter.filters.showOnlyActive = { Name: 'showOnlyActive', Value: { value: this.showOnlyActive } };
  }

  exportToExcel() {
    if (this.loadingList || this.loadingExcel) {
      return;
    }
    this.setFilter();
    this.store.dispatch(exportSelfCareCompletionListToExcel({
      filter: this.filter
    }));
  }


  getTerminationString(list) {
    if (list.terminationDate != null) {
      return "(Separated)";
    }

    if (list.inactive) {
      return "(Inactive)"
    }

    return "";
  }
}
